import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { LateralBar } from '../../../../../../components/LateralBar';
import { CustomerPrivatePensionContractedNormalized } from '../../../../../../store/customerDetail/privatePension/types';
import { PrivatePensionContractedTabProps } from '../../constants';
import { ActionButtons } from '../ActionButtons';
import { PrivatePensionCardItem } from '../PrivatePensionCardItem';

import { getPrivatePensionCardInfos, ItemDataInfo } from './constants';

export interface PrivatePensionCardProps extends PrivatePensionContractedTabProps {
  privatePensionContracted: CustomerPrivatePensionContractedNormalized;
}

export const PrivatePensionCard: React.FC<PrivatePensionCardProps> = ({
  setSelectedTab,
  privatePensionContracted,
}) => {
  const numColumns = useBreakpointValue({ base: 1, sm: 4, lg: 6 });

  const renderInfo = (item: ItemDataInfo) => {
    return <PrivatePensionCardItem label={item.label} value={item.value} numColumns={numColumns} />;
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy} p={Spacing['stack.xxxs']}>
      <LateralBar barColor="product.previdencia" />
      <VStack space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <UI.Text variant="semibold" color="neutral.dark" textTransform="uppercase">
            {privatePensionContracted.insurer}
          </UI.Text>
          <ActionButtons
            privatePension={privatePensionContracted}
            setSelectedTab={setSelectedTab}
          />
        </HStack>
        <Box w="full" h="1px" backgroundColor={Color['neutral.lightest']} />
        <FlatList
          key={`private-pension-card-flatlist-${numColumns}`}
          data={getPrivatePensionCardInfos(privatePensionContracted)}
          showsVerticalScrollIndicator={false}
          renderItem={({ item }) => renderInfo(item)}
          ItemSeparatorComponent={() => <Box h="16px" />}
          numColumns={numColumns}
        />
      </VStack>
    </UI.Shadow>
  );
};
